module.exports = __webpack_public_path__ + "static/employsure-85b851ff6deaf7469b424ee52b0f10f1.svg";